import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-menu-x",
  "use": "icon-icon-menu-x-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-menu-x\">\n<rect x=\"7.51465\" y=\"23.0711\" width=\"22\" height=\"2\" transform=\"rotate(-45 7.51465 23.0711)\" fill=\"white\" />\n<rect x=\"23.071\" y=\"24.4853\" width=\"22\" height=\"2\" transform=\"rotate(-135 23.071 24.4853)\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol